var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { styled } from 'styled-components';
export var Text = styled.p.withConfig({ displayName: "Text", componentId: "sc-95u5e3" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  white-space: pre-line;\n  margin: 0;\n"], ["\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  white-space: pre-line;\n  margin: 0;\n"])));
var templateObject_1;
